import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { isDocFlowActiveWidgetSplitting } from '../../DocFlow.utils.widgets'
import { DocFlowMappingProcessCell } from '../../DocFlowMapping'
import {
  getWidgetSplittingTypeOptions,
  isDocFlowSplittingTypeArea,
} from '../../DocFlowWidgets'
import { useDocFlowMappingContext } from '../useDocFlowMappingContext'
import { DocFlowMappingWidgetWithSelectedAreaNotificationType } from '../useDocFlowMappingWidgetWithSelectedArea'

export function useDocFlowMappingWidgetSplittingFields({
  widgetDisabled,
  widgetNotifications,
  onChangeAccuracy,
  onDebounceWidgetGetSelectedAreaInfo,
  onGetSplittingSelectedAreaInfo,
  onPrependNotification,
  onRemoveAdditionalNotifications,
  onRemoveNotification,
}) {
  const {
    activeWidget,
    hideSelectArea,
    isChanged,
    isChanging,
    isInitSelectArea,
    processData,
    selectedBox,
    setChanged,
    showSelectArea,
  } = useDocFlowMappingContext()

  const { values } = useFormikContext()
  const typeValue = values[DocFlowMappingProcessCell.SplittingType]

  const options = getWidgetSplittingTypeOptions()

  const isTypeArea = isDocFlowSplittingTypeArea(typeValue?.value)

  const needToGetSelectAreaInfo = (isChanged || isChanging) && isTypeArea

  function handleChangeType(value) {
    onRemoveAdditionalNotifications()

    if (isDocFlowSplittingTypeArea(value.value)) {
      showSelectArea()
      setChanged(null)
    } else {
      hideSelectArea()
      onRemoveNotification(
        widgetNotifications?.[
          DocFlowMappingWidgetWithSelectedAreaNotificationType.Phase
        ].id
      )
    }
  }

  const isSplittingWidget = isDocFlowActiveWidgetSplitting(activeWidget)

  function handleChangeAccuracy(values) {
    if (needToGetSelectAreaInfo) {
      onChangeAccuracy(values)
    }
  }

  useEffect(() => {
    if (
      isTypeArea &&
      isSplittingWidget &&
      !selectedBox &&
      processData?.[DocFlowMappingProcessCell.SplittingArea]?.length === 0
    ) {
      onPrependNotification({
        ...widgetNotifications?.[
          DocFlowMappingWidgetWithSelectedAreaNotificationType.Phase
        ],
        type: NOTIFICATION_TYPE.info,
      })
    }
  }, [
    isSplittingWidget,
    isTypeArea,
    processData,
    selectedBox,
    widgetNotifications,
  ])

  useEffect(() => {
    if (isSplittingWidget) {
      onRemoveAdditionalNotifications()

      if (isChanged) {
        onDebounceWidgetGetSelectedAreaInfo(values)

        onRemoveNotification(
          widgetNotifications?.[
            DocFlowMappingWidgetWithSelectedAreaNotificationType.NotChanged
          ].id
        )
      }
    }
  }, [isChanged, onRemoveAdditionalNotifications])

  useEffect(() => {
    if (
      processData?.[DocFlowMappingProcessCell.SplittingArea]?.length > 0 &&
      isSplittingWidget &&
      selectedBox &&
      isInitSelectArea &&
      !isChanging &&
      !isChanged &&
      !widgetDisabled
    ) {
      onGetSplittingSelectedAreaInfo(values)
    }
  }, [
    isChanged,
    isChanging,
    isInitSelectArea,
    isSplittingWidget,
    processData,
    selectedBox,
    widgetDisabled,
  ])

  return {
    handleChangeAccuracy,
    handleChangeType,
    isTypeArea,
    options,
  }
}
